import styled from 'styled-components';

export const DropdownOption = styled.div`
  a {
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: 0.5s;
  }

  a:after {
    content: '»';
    position: absolute;
    opacity: 0;
    top: 16px;
    right: 20px;
    transition: 0.5s;
  }

  a:hover {
    padding-right: 24px;
  }

  a:hover:after {
    opacity: 1;
    right: 10px;
  }
`;
const customColors = {
  greenInternational1: '#34BF42',
  greenInternational2: '#a6fff3',
  greenInternational3: '#b1f98a',
  cardGreen1: '#a9c763',
  cardGreen2: '#9dd57d',
  cardGreen3: '#73aca4',
};

const {
  greenInternational1,
  greenInternational2,
  greenInternational3,
  cardGreen1,
  cardGreen2,
  cardGreen3,
} = customColors;

export const HeaderStyles = styled.div`
  .greenRoundButton {
    background: ${greenInternational1};
    border-radius: 40px;
  }
  .ovalButton {
    border-radius: 40px;
  }
  input:focus-visible {
    outline: none;
  }
`;

export const InternationalFirstFold = styled.div`
  background: url(https://assets1.cleartax-cdn.com/cleartax/images/1675428973_arrox_bg_ani.gif);
  .greenRoundButton {
    background: ${greenInternational1};
    border-radius: 40px;
  }
  .ovalButton {
    border-radius: 40px;
  }

  .firstFoldButtons {
    gap: 24px;
  }

  input:focus-visible {
    outline: none;
  }
`;

export const InternationalThirdFold = styled.div`
  .colorfulText {
    background: linear-gradient(
      92.51deg,
      ${greenInternational2} 7.84%,
      ${greenInternational3} 94.47%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .ThirdFoldCard {
    background: linear-gradient(
      201.88deg,
      ${cardGreen1} 3.34%,
      ${cardGreen2} 55.19%,
      ${cardGreen3} 100%
    );
    border-radius: 38px;
  }
`;

export const InternationalFifthFold = styled.div`
  background: linear-gradient(
    46.26deg,
    ${greenInternational2} -20.97%,
    ${greenInternational3} 57.58%,
    ${greenInternational1} 195.76%
  );
  p {
    font-size: 80px;
  }

  @media (max-width: 768px) {
    p {
      font-size: 32px;
    }
  }
`;

export const InternationalSixthFold = styled.div`
  background-image: url('https://assets1.cleartax-cdn.com/cleartax/images/1675578156_group1000003362.png');
  .round-tick {
    height: 18px;
    width: 18px;
  }
  .colorfulText {
    background: linear-gradient(
      79.83deg,
      ${greenInternational2} -5.15%,
      ${greenInternational3} 56.52%,
      ${greenInternational1} 138.08%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media (max-width: 768px) {
    background-image: url('https://assets1.cleartax-cdn.com/cleartax/images/1675665220_group1000003363.png');
    background-size: auto;
    background-position: center;
  }
`;

export const InternationalSeventhFold = styled.div`
  background-image: url('https://assets1.cleartax-cdn.com/cleartax/images/1675614852_shutterstock_116653052511.png'),
    linear-gradient(
      46.26deg,
      ${greenInternational2} -20.97%,
      ${greenInternational3} 57.58%,
      ${greenInternational1} 195.76%
    );
  background-position: bottom right;
  background-repeat: no-repeat;

  .ovalButton {
    border-radius: 40px;
  }

  .greenRoundButton {
    background: ${greenInternational1};
    border-radius: 40px;
  }

  @media (max-width: 768px) {
    background-image: linear-gradient(
      46.26deg,
      ${greenInternational2} -20.97%,
      ${greenInternational3} 57.58%,
      ${greenInternational1} 195.76%
    );
  }
`;
